<template>
  <v-container fluid class="pa-0">
    <v-img
      src="https://medicover.mx/img/Promotioncarrer.svg"
      cover
      gradient="to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.7)"
      class="white--text d-flex align-center justify-center promotion-img"
    >
      <!-- Contenedor centrado -->
      <v-container fill-height fluid class="d-flex align-center justify-center">
        <v-row align="center" justify="center" class="text-center">
          <v-col cols="12" md="10" lg="8">
            
            <!-- Texto superior -->
            <div class="caption font-weight-bold white--text mb-4">
              OFERTA • EXCLUSIVA
            </div>

            <!-- Título adaptativo -->
            <div>
              <h1 class="display-2 font-weight-black mb-4 white--text hidden-sm-and-down">
                ¡Con MediCover cuida tu rendimiento y salud!
              </h1>
              <h1 class="display-1 font-weight-black mb-4 white--text hidden-md-and-up">
                ¡Con MediCover y sus coberturas cuida tu rendimiento y salud!
              </h1>
            </div>

            <!-- Subtítulo -->
            <p class="subtitle-1 white--text mb-8">
              Con la cobertura de citas médicas con especialistas como Fisioterapeutas, Nutriólogos y mucho más, puedes cuidar de tu salud y la de tu familia.
            </p>

            <!-- Botones principales -->
            <v-row justify="center" class="mb-6">
              <v-btn
                large
                color="primary"
                class="mx-2"
                to="/cotizador"
              >
                COTIZA EN 1 MINUTO
              </v-btn>

              <v-btn
                large
                outlined
                color="white"
                class="mx-2"
                @click="whatsappLink"
              >
                Contactar
              </v-btn>
            </v-row>

            <!-- Badge de promoción -->
            <v-row justify="center">
              <v-chip color="white" text-color="black" label>
                Promoción especial 10% de descuento al contratar
              </v-chip>
            </v-row>

          </v-col>
        </v-row>
      </v-container>
    </v-img>
  </v-container>
</template>

<script>
export default {
  name: "PromoHero",
  props: {
    title: {
      type: String,
      default: "Lanza tu promoción aquí",
    },
    subtitle: {
      type: String,
      default:
        "Un texto breve, claro y persuasivo que explique el beneficio principal. Máximo dos líneas.",
    },
    kicker: {
      type: String,
      default: "NUEVO • EXCLUSIVO",
    },
    primaryText: {
      type: String,
      default: "Conocer más",
    },
    secondaryText: {
      type: String,
      default: "Contactar",
    },
    heroSrc: {
      type: String,
      // Reemplaza con tu imagen (ideal 1920x1080 o superior)
      default:
        "https://medicover.mx/img/Promotioncarrer.svg",
    },
    lazySrc: {
      type: String,
      default:
        "data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='9' viewBox='0 0 16 9'%3E%3Crect width='16' height='9' fill='%23eee'/%3E%3C/svg%3E",
    },
    badge: {
      type: String,
      default: "",
    },
  },
    methods: {
    whatsappLink() {
      var url= `https://wa.me/${process.env.VUE_APP_BASE_PHONEWHATSWEB}?text=${encodeURIComponent('Hola quisiera una cotización descuento 10% exclusiva')}`;
      window.open(url, '_blank');
    },
  }
};
</script>

<style lang="scss" scoped>
.promotion-img {
  width: 100%;
  height: 100vh;
  object-fit: cover;
  position: relative;
}

/* Ajustes responsivos */
@media (max-width: 960px) {
  .promotion-img {
    height: 60vh;
  }
}

@media (max-width: 600px) {
  .promotion-img {
    height: 60vh;
  }
}
</style>